function isLav(o) {
    if (o && typeof o === 'object' && 'label' in o && typeof o.label === 'string' && 'value' in o) {
        return true;
    }
    return false;
}
function isLavOption(o) {
    if (typeof o === 'string') {
        return true;
    }
    return isLav(o);
}

export { isLav as a, isLavOption as i };

//# sourceMappingURL=types.js.map